export default "__VITE_ASSET__111f9d6d__"